<template>
  <Dashboard title="Modules">
    <div
      id="modules"
      v-if="selectedApplicationId"
    >
      <h3
        v-if="modules.tipcatitem.label !== undefined"
        style="margin-bottom: 15px;"
      >
        {{ modules.tipcatitem.label }}
      </h3>

      <Dropdown :title="modules.currentModuleTitle">
        <DropdownList :list="modules.dropdownList"/>
      </Dropdown>

      <Button
        class="pages--add-button"
        title="Add"
        to=""
        active=true
        showAddIcon=true
        v-on:handleClick="handleModal(undefined, 'Add', 0)"
      />

      <!-- faqlist -->
      <Table
        recordsfoundishidden=true
        :data="modules.faqlist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'faqlist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Question</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)"
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.faqlist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle
              :title="item.question"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"
                v-on:handleClick="handleModal(item, 'Edit', 0)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- textlist -->
      <Table
        recordsfoundishidden=true
        :data="modules.textlist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'textlist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th>Code</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            class="table--content"
            v-for="(item, index) of modules.textlist"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdTitle              
              :title="item.code"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- tipcatlist -->
      <Table
        recordsfoundishidden=true
        :data="modules.tipcatlist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'tipcatlist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Category</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)" 
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.tipcatlist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle
              :title="item.label"
            />

            <TdButtons>
              <RoundedButton
                title="Tip"
                v-on:handleClick="handleTipsButton(item.id)"
              />

              <RoundedButton
                title="Edit"
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- tiplist -->      
      <Table
        recordsfoundishidden=true
        :data="modules.tiplist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'tiplist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)" 
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.tiplist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"                
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- motivators -->
      <Table
        recordsfoundishidden=true
        :data="modules.motivatorlist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'motivatorlist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Image</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            class="table--content"
            v-for="(item, index) of modules.motivatorlist"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <td class="td--image">
              <img :src="item.image"/>
            </td>

            <TdButtons>
              <RoundedButton
                title="Edit"
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- issues -->
      <Table
        recordsfoundishidden=true
        :data="modules.issuelist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'issuelist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th>Situation</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)" 
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.issuelist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdTitle              
              :title="item.situation"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"                
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- moments -->
      <Table
        recordsfoundishidden=true
        :data="modules.momentlist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'momentlist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)" 
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.momentlist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdButtons>
              <RoundedButton
                title="Strategy"                
                v-on:handleClick="handleMomentButton(item.id)"
              />

              <RoundedButton
                title="Edit"                
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- momentstrategy -->
      <Table
        recordsfoundishidden=true
        :data="modules.momentstrategylist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'momentstrategylist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)" 
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.momentstrategylist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdButtons>              
              <RoundedButton
                title="Edit"                
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- situations -->
      <Table
        recordsfoundishidden=true
        :data="modules.situationlist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'situationlist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            class="table--content"
            v-for="(item, index) of modules.situationlist"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"                
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <!-- strategy -->
      <Table
        recordsfoundishidden=true
        :data="modules.strategylist"
        :isloading="modules.isLoading"
        v-if="modules.currentModule === 'strategylist'"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Title</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            @dragover="(e) => onDragOver(item, index, e)" 
            @dragend="(e) => finishDrag(item, index, e)"
            @dragstart="(e) => startDrag(item, index, e)"
            v-for="(item, index) of modules.strategylist"
            class="item table--content"
            :class="{
              over: (item === over.item && item !== dragFrom),
              [over.dir]: (item === over.item && item !== dragFrom)
            }"
            draggable="true"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle              
              :title="item.title"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"                
                v-on:handleClick="handleModal(item, 'Edit', index)"
              >
                <EditIcon/>
              </RoundedButton>

              <RoundedButton
                title=""
                danger=true
                v-on:handleClick="handleDelete(index, item.id)"
              >
                <TrashIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>
    </div>

    <NoApplicationSelected v-else/>

    <Modal
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>{{ `${modal.name} ${modules.currentModuleTitle}` }}</h3>
      </template>

      <template v-slot:content>
        <!-- faq -->
        <form v-if="modules.currentModule === 'faqlist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Question"
              type="text"
              :value="modal.faq.question"
              v-model="modal.faq.question"
            />

            <div class="col-24 input">
              <p>Answer</p>

              <vue-mce
                :config="config"
                v-model="modal.faq.answer"
              />
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton(index)"
          />
        </form>

        <!-- text -->
        <form v-if="modules.currentModule === 'textlist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.text.title"
              v-model="modal.text.title"
            />

            <Input
              class="col-24"
              placeholder="Code"
              type="text"
              :value="modal.text.code"
              v-model="modal.text.code"
            />

            <div class="col-24 input">
              <p>Content</p>

              <vue-mce
                :config="config"
                v-model="modal.text.content"
              />
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton(index)"
          />         
        </form>

        <!-- tipcat -->
        <form v-if="modules.currentModule === 'tipcatlist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Category"
              type="text"
              :value="modal.tipcat.label"
              v-model="modal.tipcat.label"
            />

            <Input
              class="col-24"
              placeholder="Icon"
              type="text"
              :value="modal.tipcat.icon"
              v-model="modal.tipcat.icon"
            />
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>

        <!-- tip -->
        <form v-if="modules.currentModule === 'tiplist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.tip.title"
              v-model="modal.tip.title"
            />

            <div class="col-12 input">
              <p>Select video</p>

              <SelectionModuleVideo v-on:handleClick="handleSelectionModuleVideoClick"/>
            </div>

            <div class="col-6 input">
              <p>Selected video</p>

              <!-- MARK: somehow is the state of ratio block image not updating this is a hack to fix this issue -->
              <div class="tip-placeholder">{{ modal.tip }}</div>

              <RatioBlockImage
                v-if="modal.tip.preview !== ''"
                class="motivator-image"
                :src="modal.tip.preview"
              />

              <div v-else>
                No video selected
              </div>

              <ButtonForm
                v-if="modal.tip.preview !== ''"
                class="modules--remove-button"
                title="Remove video"
                v-on:handleClick="handleModalRemoveVideo()"
              />
            </div>

            <div class="col-24 input">
              <p>Intro</p>

              <textarea v-model="modal.tip.intro"/>
            </div>

            <div class="col-24 input">
              <p>Content</p>

              <vue-mce
                :config="config"
                v-model="modal.tip.content"
              />
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>

        <!-- motivators -->
        <form v-if="modules.currentModule === 'motivatorlist'">
          <div class="row">
            <div class="col-12 input">
              <p>Select image</p>

              <SelectionModuleImage v-on:handleClick="handleSelectionModuleImageClick"/>
            </div>

            <div class="col-6 input">
              <p>Selected image</p>

              <RatioBlockImage
                v-if="modal.motivator.image !== ''"
                class="motivator-image"
                :src="modal.motivator.image"
              />
              
              <div v-else>
                No image selected
              </div>
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>
            
        <!-- issues -->
        <form v-if="modules.currentModule === 'issuelist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.issue.title"
              v-model="modal.issue.title"
            />

            <div class="col-12 input">
              <p>Situation</p>
              
              <RadioInput
                v-for="(radioItem, index) in modules.situationlist"
                v-bind:key="index"
                :placeholder="radioItem.title"
                :name="`issueRadio`"
                :checked="radioItem.title === modal.issue.situation"
                v-on:handleClick="handleIssueRadio(radioItem.id, radioItem.title)"
              />
            </div>
            
            <div class="col-24 input">
              <p>Description</p>

              <vue-mce
                :config="config"
                v-model="modal.issue.description"
              />
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>

        <!-- moments -->
        <form v-if="modules.currentModule === 'momentlist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.moment.title"
              v-model="modal.moment.title"
            />

            <div class="col-24 input">
              <p>Intro</p>

              <vue-mce
                :config="config"
                v-model="modal.moment.intro"
              />
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>

        <!-- momentstrategy -->
        <form v-if="modules.currentModule === 'momentstrategylist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.momentstrategy.title"
              v-model="modal.momentstrategy.title"
            />

            <div class="col-24 input">
              <p>Text</p>

              <textarea v-model="modal.momentstrategy.text"/>
            </div>

            <div class="col-24 input">
              <p>Extra info</p>

              <vue-mce
                :config="config"
                v-model="modal.momentstrategy.info"
              />
            </div>

            <Input
              class="col-24"
              placeholder="Link"
              type="text"
              :value="modal.momentstrategy.link"
              v-model="modal.momentstrategy.link"
            />
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>

        <!-- situations -->
        <form v-if="modules.currentModule === 'situationlist'">
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.situation.title"
              v-model="modal.situation.title"
            />

            <div class="col-24 input">
              <p>Description</p>

              <vue-mce
                :config="config"
                v-model="modal.situation.description"
              />
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>

        <!-- strategy -->
        <form v-if="modules.currentModule === 'strategylist'">
          <div class="row">
            <div
              v-if="modal.name !== 'Add'"
              class="col-24 input"
            >
              <div class="row">
                <div class="col-12">
                  <p>Selected moments</p>

                  <ul class="strategylist-moments">
                    <li
                      class="momentsSelected-item"
                      v-for="(itemSelected, index) in modal.strategy.momentsSelected"
                      v-bind:key="index"
                      v-on:click="handleMomentsSelectedItem(itemSelected, index)"
                    >
                      {{ itemSelected.id }}
                      {{ itemSelected.title }}
                    </li>
                  </ul>
                </div>

                <div class="strategy-buttons">
                  <a v-on:click="handleRight">▶</a>
                  <!-- <a v-on:click="handleRightRight">▶▶</a> -->
                  <!-- <a v-on:click="handleLeftLeft">▶▶</a> -->
                  <a v-on:click="handleLeft">▶</a>
                </div>

                <div class="col-12">
                  <p>Available moments</p>

                  <ul class="strategylist-moments">
                    <li
                      class="momentsAvailable-item"
                      v-for="(itemSelected, index) in modal.strategy.availableMinusMomentsSelected"
                      v-bind:key="index"
                      v-on:click="handleMomentsAvailableItem(itemSelected, index)"
                    >
                      {{ itemSelected.id }}
                      {{ itemSelected.title }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.strategy.title"
              v-model="modal.strategy.title"
            />

            <div class="col-24 input">
              <p>Text</p>

              <textarea v-model="modal.strategy.text"/>
            </div>

            <div class="col-24 input">
              <p>Extra info</p>

              <vue-mce
                :config="config"
                v-model="modal.strategy.info"
              />
            </div>
            
            <div class="col-12 input">
              <p>Select podcast</p>

              <SelectionModuleMP3 v-on:handleClick="handleSelectionModuleMP3Click"/>
            </div>

            <div class="col-12 input">
              <p>Selected podcast</p>

              <span v-if="modal.strategy.podcast !== ''">{{ modal.strategy.podcast_id }} {{ modal.strategy.podcast }}</span>

              <span v-else>No podcast selected</span>

              <ButtonForm
                v-if="modal.strategy.podcast !== ''"
                class="modules--remove-button"
                title="Remove podcast"
                v-on:handleClick="handleModalRemovePodcast()"
              />
            </div>

            <Input
              class="col-24"
              placeholder="Link"
              type="text"
              :value="modal.strategy.link"
              v-model="modal.strategy.link"
            />
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>
    </Modal>
  </Dashboard>  
</template>

<script>
  import { API } from '../../services/api.ts'
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import Button from '../../components/buttons/button.vue'
  import RoundedButton from '../../components/buttons/roundedButton.vue'
  import NoApplicationSelected from '../../components/error/noApplicationSelected.vue'
  import Modal from '../../components/modal/modal.vue'
  import Input from '../../components/form/input.vue'
  import RadioInput from '../../components/form/radio.vue'
  import ButtonForm from '../../components/form/button.vue'

  import Dropdown from '../../components/dropdown/dropdown.vue'
  import DropdownList from '../../components/dropdown/content/list.vue'

  import Table from '../../components/table/table.vue'
  import TdTitle from '../../components/table/td/title.vue'
  import TdId from '../../components/table/td/id.vue'
  import TdSortOrder from '../../components/table/td/sortOrder.vue'
  import TdButtons from '../../components/table/td/buttons.vue'
  import TrashIcon from '../../icons/trash.vue'
  import EditIcon from '../../icons/edit.vue'  
  import SelectionModuleImage from '../../components/storage/selectionModules/image.vue';
  import SelectionModuleMP3 from '../../components/storage/selectionModules/mp3.vue';
  import SelectionModuleVideo from '../../components/storage/selectionModules/video.vue';
  import RatioBlockImage from '../../components/ratioBlock/ratioBlockImage.vue'
  import { component } from 'vue-mce';

  export default {
    name: 'Pages',
    components: {
      Dashboard,
      Button,
      RoundedButton,
      NoApplicationSelected,
      Modal,
      Input,
      RadioInput,
      ButtonForm,
      Dropdown,
      DropdownList,
      Table,
      TdTitle,
      TdId,
      TdSortOrder,
      TdButtons,
      TrashIcon,
      EditIcon,
      SelectionModuleImage,
      SelectionModuleMP3,
      SelectionModuleVideo,
      RatioBlockImage,
      'vue-mce': component
    },
    data() {
      return {
        config: {
          theme: 'modern',          
          menubar: false,
          plugins: 'code lists link',
          toolbar: 'styleselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code',
          style_formats : [
            {title : 'H2', block : 'h2'},
            {title : 'H3', block : 'h3'},
            {title : 'H4', block : 'h4'},
            {title: 'Color block', inline: 'span', classes: 'well', styles: { backgroundColor: 'whitesmoke', display: 'block'}},
            {title : 'Quotation', block : 'blockquote'},
          ]
        },
        selectedApplicationId: localStorage.selectedApplicationId,
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
        selectedMomentsSelectedItem: {
          id: 0,
          title: ''
        },
        selectedMomentsAvailableItem: {
          id: 0,
          title: ''
        },
        modules: {
          isLoading: true,
          dropdownList: [
            {
              label: 'FAQ',
              to: '/modules/faq'
            },
            {
              label: 'Text',
              to: '/modules/text'
            },
            {
              label: 'Tips',
              to: '/modules/tips'
            },
            {
              label: 'Motivators',
              to: '/modules/motivators'
            },
            {
              label: 'Issues',
              to: '/modules/issues'
            },
            {
              label: 'Moments',
              to: '/modules/moments'
            },
            {
              label: 'Situations',
              to: '/modules/situations'
            },
            {
              label: 'Strategy',
              to: '/modules/strategy'
            }
          ],
          currentModule: '',
          currentModuleTitle: 'FAQ',
          faqlist: [],
          textlist: [],
          tipcatlist: [],
          tiplist: [],
          tipcatitem: {},
          motivatorlist: [],
          issuelist: [],
          momentlist: [],
          momentstrategylist: [],
          situationlist: [],
          strategylist: []
        },
        modal: {
          isHidden: true,
          name: '',
          id: 0,
          faq: {
            question: '',
            answer: '',
            code: ''
          },
          text: {
            title: '',
            code: '',
            content: ''
          },
          tipcat: {
            label: '',
            icon: '',
            rank: 0
          },
          tip: {
            title: '',
            video: '',
            intro: '',
            content: '',
            rank: 0
          },
          motivator: {
            image: '',
            id: 0
          },
          issue: {
            situation: '',
            situation_id: 0,
            title: '',
            description: '',
            rank: 0
          },
          moment: {
            title: '',
            intro: '',
            rank: 0
          },
          momentstrategy: {
            info: '',
            link: '',
            rank: 0,
            text: '',
            title: ''
          },
          situation: {
            description: '',
            title: ''
          },
          strategy: {
            title: '',
            text: '',
            info: '',
            podcast: '',
            podcast_id: 0,
            link: '',
            momentsAvailable: [],
            momentsSelected: [],
            availableMinusMomentsSelected: []
          }
        }
      }
    },
    methods: {
      startDrag(item, i, e) {
        this.startLoc = e.clientY;
        this.dragging = true;
        this.dragFrom = item;
      },
      finishDrag(item, pos) {
        switch (this.$route.name) {
          case 'faq':
            this.modules.faqlist.splice(pos, 1)
            this.modules.faqlist.splice(this.over.pos, 0, item);
            this.over = {}

            for (const [index, arrayItem] of this.modules.faqlist.entries()) {
              arrayItem.rank = index + 1;

              console.log(arrayItem);

              API.patch(
                `index.cfm?act=modules.faqitem&id=${arrayItem.id}`,
                {
                  rank: `${index + 1}`
                }
              ).then(
                response => {
                  console.log(response.data.data);
                }
              )
            }
            break;

          case 'tips':
            this.modules.tipcatlist.splice(pos, 1)
            this.modules.tipcatlist.splice(this.over.pos, 0, item);
            this.over = {}

            for (const [index, arrayItem] of this.modules.tipcatlist.entries()) {
              arrayItem.rank = index + 1;

              console.log(arrayItem);

              API.patch(
                `index.cfm?act=modules.tipcatitem&id=${arrayItem.id}`,
                {
                  rank: `${index + 1}`
                }
              ).then(
                response => {
                  console.log(response.data.data);
                }
              )
            }
            break;

          case 'tip':
            this.modules.tiplist.splice(pos, 1)
            this.modules.tiplist.splice(this.over.pos, 0, item);
            this.over = {}

            for (const [index, arrayItem] of this.modules.tiplist.entries()) {
              arrayItem.rank = index + 1;

              console.log(arrayItem);

              API.patch(
                `index.cfm?act=modules.tipitem&id=${arrayItem.id}`,
                {
                  rank: `${index + 1}`
                }
              ).then(
                response => {
                  console.log(response.data.data);
                }
              )
            }
            break;

          case 'issues':
            this.modules.issuelist.splice(pos, 1)
            this.modules.issuelist.splice(this.over.pos, 0, item);
            this.over = {}

            for (const [index, arrayItem] of this.modules.issuelist.entries()) {
              arrayItem.rank = index + 1;

              console.log(arrayItem);

              API.patch(
                `index.cfm?act=modules.issueitem&id=${arrayItem.id}`,
                {
                  rank: `${index + 1}`
                }
              ).then(
                response => {
                  console.log(response.data.data);
                }
              )
            }
            break;
          
          case 'moments':
            this.modules.momentlist.splice(pos, 1)
            this.modules.momentlist.splice(this.over.pos, 0, item);
            this.over = {}

            for (const [index, arrayItem] of this.modules.momentlist.entries()) {
              arrayItem.rank = index + 1;

              console.log(arrayItem);

              API.patch(
                `index.cfm?act=modules.momentitem&id=${arrayItem.id}`,
                {
                  rank: `${index + 1}`
                }
              ).then(
                response => {
                  console.log(response.data.data);
                }
              )
            }
            break;
            
          case 'momentstrategy':
            this.modules.momentstrategylist.splice(pos, 1)
            this.modules.momentstrategylist.splice(this.over.pos, 0, item);
            this.over = {}

            for (const [index, arrayItem] of this.modules.momentstrategylist.entries()) {
              arrayItem.rank = index + 1;

              console.log(arrayItem);

              API.patch(
                `index.cfm?act=modules.momentstrategyitem&momentid=${arrayItem.id}`,
                {
                  rank: `${index + 1}`
                }
              ).then(
                response => {
                  console.log(response.data.data);
                }
              )
            }
            break;
        }
      },
      onDragOver(item, pos, e) {
        const dir = (this.startLoc < e.clientY) ? 'down': 'up';
        setTimeout(() => {
          this.over = { item, pos, dir };        
        }, 10)
      },
      handleTipsButton: function(id) {
        window.location.href = `/modules/tips/${id}`;
      },
      handleMomentButton: function(id) {
        window.location.href = `/modules/moments/${id}`;
      },
      handleModal: function(data, name, index) {
        this.modal.name = name;

        // show / hide
        if (this.modal.isHidden === true) {
          this.modal.isHidden = false;

          if (data !== undefined) {
            this.modal.id = data.id;
          }

          switch (this.$route.name) {
            case 'faq':
              if (data !== undefined) {
                this.modal.faq.question = data.question;
                this.modal.faq.answer = data.answer;
                this.modal.faq.code = data.answer;
                this.modal.faq.index = index;
              } else {
                this.modal.faq.question = '';
                this.modal.faq.answer = '';
                this.modal.faq.code = '';
              }
              break;

            case 'text':
              if (data !== undefined) {
                this.modal.text.title = data.title;
                this.modal.text.code = data.code;
                this.modal.text.content = data.content;
                this.modal.text.index = index;
              } else {
                this.modal.text.title = '';
                this.modal.text.code = '';
                this.modal.text.content = '';
              }
              break;
            
            case 'tips':
              if (data !== undefined) {
                this.modal.tipcat.label = data.label;
                this.modal.tipcat.index = index;
              } else {
                this.modal.tipcat.label = '';
              }
              break;

            case 'tip':
              if (data !== undefined) {
                this.modal.tip.title = data.title;
                this.modal.tip.video = data.video;
                this.modal.tip.intro = data.intro;
                this.modal.tip.content = data.content;
                this.modal.tip.preview = data.videopreview;
                this.modal.tip.index = index;
              } else {
                this.modal.tip.title = '';
                this.modal.tip.video = '';
                this.modal.tip.intro = '';
                this.modal.tip.content = '';
                this.modal.tip.preview = '';
              }
              break;

            case 'motivators':
              if (data !== undefined) {
                this.modal.motivator.image = data.image;
                this.modal.motivator.image_id = data.image_id;
                this.modal.motivator.index = index;
              } else {
                this.modal.motivator.image = '';
              }
              break;

            case 'issues':
              if (data !== undefined) {
                this.modal.issue.title = data.title;
                this.modal.issue.situation = data.situation;
                this.modal.issue.situation_id = data.situation_id;
                this.modal.issue.description = data.description;
                this.modal.issue.index = index;
              } else {
                this.modal.issue.title = '';
                this.modal.issue.situation = '';
                this.modal.issue.situation_id = 0;
                this.modal.issue.description = '';
              }
              break;

            case 'moments':
              if (data !== undefined) {
                this.modal.moment.title = data.title;
                this.modal.moment.intro = data.intro;
                this.modal.moment.index = index;
              } else {
                this.modal.moment.title = '';
                this.modal.moment.intro = '';
              }
              break;

            case 'momentstrategy':
              if (data !== undefined) {
                this.modal.momentstrategy.title = data.title;
                this.modal.momentstrategy.text = data.text;
                this.modal.momentstrategy.info = data.info;
                this.modal.momentstrategy.link = data.link;
                this.modal.momentstrategy.index = index;
              } else {
                this.modal.momentstrategy.title = '';
                this.modal.momentstrategy.text = '';
                this.modal.momentstrategy.info = '';
                this.modal.momentstrategy.link = '';
              }
              break;

            case 'situations':
              if (data !== undefined) {
                this.modal.situation.title = data.title;
                this.modal.situation.description = data.description;
                this.modal.situation.index = index;
              } else {
                this.modal.situation.title = '';
                this.modal.situation.description = '';
              }
              break;

            case 'strategy':
              if (data !== undefined) {
                this.modal.strategy.title = data.title;
                this.modal.strategy.text = data.text;
                this.modal.strategy.info = data.info;
                this.modal.strategy.podcast_id = data.podcast_id;
                this.modal.strategy.link = data.link;
                this.modal.strategy.momentsAvailable = data.momentsAvailable;
                this.modal.strategy.momentsSelected = data.momentsSelected;
                this.modal.strategy.index = index;
                this.modal.strategy.availableMinusMomentsSelected = this.strategyMomentsAvailableMinusMomentsSelected(data.momentsAvailable, data.momentsSelected);
              } else {
                this.modal.strategy.title = '';
                this.modal.strategy.text = '';
                this.modal.strategy.info = '';
                this.modal.strategy.podcast_id = 0;
                this.modal.strategy.link = '';
                this.modal.strategy.momentsAvailable = [];
                this.modal.strategy.momentsSelected = [];
              }
              break; 
          }
        } else {
          this.modal.isHidden = true;
        }
      },
      handleIssueRadio: function(id, title) {
        this.modal.issue.situation_id = id;
        this.modal.issue.situation = title;
      },
      clearSelectedMoments: function() {
        const selectedItems = this.$el.querySelectorAll('.momentsSelected-item');
        const availableItem = this.$el.querySelectorAll('.momentsAvailable-item');

        for (let i = 0; i < selectedItems.length; i++) {
          const element = selectedItems[i];
          element.style.backgroundColor = 'transparent';
        }

        for (let i = 0; i < availableItem.length; i++) {
          const element = availableItem[i];
          element.style.backgroundColor = 'transparent';
        }
      },
      strategyMomentsAvailableMinusMomentsSelected: function(available, selected) {
        for (let i = 0; i < selected.length; i++) {
          const element = selected[i];
        
          available.splice(available.findIndex(item => item.id === element.id), 1)
        }

        return available;
      },
      handleMomentsSelectedItem: function(item, index) {
        const selectedItems = this.$el.querySelectorAll('.momentsSelected-item');
        this.clearSelectedMoments();
        selectedItems[index].style.backgroundColor = '#BCE0FD';

        this.selectedMomentsSelectedItem.id = item.id;
        this.selectedMomentsSelectedItem.title = item.title;
        this.selectedMomentsSelectedItem.index = index;
      },
      handleMomentsAvailableItem: function(item, index) {
        const availableItem = this.$el.querySelectorAll('.momentsAvailable-item');
        this.clearSelectedMoments();
        availableItem[index].style.backgroundColor = '#BCE0FD';

        this.selectedMomentsSelectedItem.id = item.id;
        this.selectedMomentsSelectedItem.title = item.title;
        this.selectedMomentsSelectedItem.index = index;
      },
      handleRight: function() {
        this.clearSelectedMoments();

        API.patch(
          `index.cfm?act=modules.strategyitem&id=${this.modal.id}`,
          {
            removeMoments: `${this.selectedMomentsSelectedItem.id}`
          }
        ).then(
          response => {
            console.log(response);
          }
        )

        let selectedMomentsSelectedItem = {
          id: this.selectedMomentsSelectedItem.id,
          index: this.selectedMomentsSelectedItem.index,
          title: this.selectedMomentsSelectedItem.title
        }

        this.modal.strategy.momentsSelected.splice(this.selectedMomentsSelectedItem.index, 1);
        this.modal.strategy.momentsAvailable.push(selectedMomentsSelectedItem);
      },
      handleLeft: function() {
        this.clearSelectedMoments();
        
        API.patch(
          `index.cfm?act=modules.strategyitem&id=${this.modal.id}`,
          {
            addMoments: `${this.selectedMomentsSelectedItem.id}`
          }
        ).then(
          response => {
            console.log(response);  
          }
        )

        let selectedMomentsAvailableItem = {
          id: this.selectedMomentsSelectedItem.id,
          index: this.selectedMomentsSelectedItem.index,
          title: this.selectedMomentsSelectedItem.title
        }

        this.modal.strategy.momentsAvailable.splice(this.selectedMomentsSelectedItem.index, 1);
        this.modal.strategy.momentsSelected.push(selectedMomentsAvailableItem);
      },
      // handleRightRight: function() {
      //   for (let i = 0; i < this.modal.strategy.momentsSelected.length; i++) {
      //     const element = this.modal.strategy.momentsSelected[i];
          
      //     this.modal.strategy.momentsAvailable.push(element);
      //   }
        
      //   this.modal.strategy.momentsSelected = [];
      // },
      // handleLeftLeft: function() {
      //   for (let i = 0; i < this.modal.strategy.momentsAvailable.length; i++) {
      //     const element = this.modal.strategy.momentsAvailable[i];
          
      //     this.modal.strategy.momentsSelected.push(element);
      //   }
        
      //   this.modal.strategy.momentsAvailable = [];
      // },
      handleModalRemoveVideo: function() {
        this.modal.tip.video = 0;
        this.modal.tip.preview = '';
      },
      handleModalRemovePodcast: function() {
        this.modal.strategy.podcast = '';
      },
      handleSelectionModuleImageClick: function(item) {
        this.modal.motivator.id = item.id
        this.modal.motivator.image = item.url;
      },
      handleSelectionModuleVideoClick: function(video) {
        console.log(video);
        this.modal.tip.preview = video.preview;
        this.modal.tip.video = video.key;

        console.log(this.modal.tip);
      },
      handleSelectionModuleMP3Click: function(podcast) {
        this.modal.strategy.podcast = podcast.title;
        this.modal.strategy.podcast_id = podcast.id;
      },
      handleModalButton: function() {
        this.$el.querySelector('form').reportValidity();
        this.checkAddOrEdit();
      },
      checkAddOrEdit: function() {
        this.modal.isHidden = true;

        if (this.modal.name === 'Add') {
          this.addModule();
        } else {
          this.updateModule();
        }
      },
      addModule: function() {
        switch (this.$route.name) {
          case 'faq':
            API.post(
              'index.cfm?act=modules.faqitem',
              {
                code: this.modal.faq.code,
                question: this.modal.faq.question,
                answer: this.modal.faq.answer
              }
            ).then(
              response => {
                location.reload();
              }
            )
            break;

          case 'text':
            API.post(
              'index.cfm?act=modules.textitem',
              {
                code: this.modal.text.code,
                title: this.modal.text.title,
                content: this.modal.text.content
              }
            ).then(
              response => {                
                location.reload();
              }
            )
            break;
          
          case 'tips':
            API.post(
              'index.cfm?act=modules.tipcatitem',
              {
                label: this.modal.tipcat.label,
                icon: this.modal.tipcat.icon
              }
            ).then(
              response => {
                location.reload();
              }
            )
            break;
          case 'tip':
            API.post(
              `index.cfm?act=modules.tipitem&tipcatid=${this.$route.params.id}`,
              {
                title: this.modal.tip.title,
                video: this.modal.tip.video,
                intro: this.modal.tip.intro,
                content: this.modal.tip.content
              }
            ).then(
              response => {
                console.log(response);
                location.reload();
              }
            )
            break;

          case 'motivators':
            API.post(
              `index.cfm?act=modules.motivatoritem`,
              {
                image_id: this.modal.motivator.id
              }
            ).then(
              response => {                
                location.reload();
              }
            )
            break;

          case 'issues':
            API.post(
              `index.cfm?act=modules.issueitem`,
              {
                title: this.modal.issue.title,
                situation: this.modal.issue.situation,
                situation_id: this.modal.issue.situation_id,
                description: this.modal.issue.description
              }
            ).then(
              response => {
                location.reload();
              }
            )
            break;

          case 'moments':
            API.post(
              `index.cfm?act=modules.momentitem`,
              {
                title: this.modal.moment.title,
                intro: this.modal.moment.intro
              }
            ).then(
              response => {
                console.log(response);
                location.reload();
              }
            )
            break;

          case 'momentstrategy':
            API.post(
              `index.cfm?act=modules.momentstrategyitem&momentid=${this.$route.params.id}`,
              {
                title: this.modal.momentstrategy.title,
                text: this.modal.momentstrategy.text,
                info: this.modal.momentstrategy.info,
                link: this.modal.momentstrategy.link
              }
            ).then(
              response => {
                console.log(response);
                location.reload();
              }
            )
            break;

          case 'situations':
            API.post(
              `index.cfm?act=modules.situationitem`,
              {
                title: this.modal.situation.title,
                description: this.modal.situation.description
              }
            ).then(
              response => {
                console.log(response);
                location.reload();
              }
            )
            break;

          case 'strategy':
            API.post(
              `index.cfm?act=modules.strategyitem`,
              {
                title: this.modal.strategy.title,
                text: this.modal.strategy.text,
                info: this.modal.strategy.info,
                podcast_id: 0,
                link: this.modal.strategy.link,
                // addMoments: '',
                // removeMoments: ''
              }
            ).then(
              response => {
                console.log(response);
                location.reload();
              }
            )
            break;
        }
      },
      updateModule: function() {
        switch (this.$route.name) {
          case 'faq':
            API.patch(
              `index.cfm?act=modules.faqitem&id=${this.modal.id}`,
              {
                code: this.modal.faq.code,
                question: this.modal.faq.question,
                answer: this.modal.faq.answer
              }
            ).then(
              response => {
                this.modules.faqlist[this.modal.faq.index].question = response.data.data.question;
                this.modules.faqlist[this.modal.faq.index].answer = response.data.data.answer;
                this.modules.faqlist[this.modal.faq.index].code = response.data.data.code;
            
                this.modal.isHidden = true;
              }
            )
            break;

          case 'text':
            API.patch(
              `index.cfm?act=modules.textitem&id=${this.modal.id}`,
              {
                code: this.modal.text.code,
                title: this.modal.text.title,
                content: this.modal.text.content
              }
            ).then(
              response => {
                this.modules.textlist[this.modal.text.index].title = response.data.data.title;
                this.modules.textlist[this.modal.text.index].code = response.data.data.code;
                this.modules.textlist[this.modal.text.index].content = response.data.data.content;
            
                this.modal.isHidden = true;
              }
            )
            break;
          
          case 'tips':
            API.patch(
              `index.cfm?act=modules.tipcatitem&id=${this.modal.id}`,
              {
                label: this.modal.tipcat.label
              }
            ).then(
              response => {
                this.modules.tipcatlist[this.modal.tipcat.index].label = response.data.data.label;
            
                this.modal.isHidden = true;
              }
            )
            break;

          case 'tip':
            API.patch(
              `index.cfm?act=modules.tipitem&id=${this.modal.id}`,
              {
                title: this.modal.tip.title,
                video: this.modal.tip.video,
                intro: this.modal.tip.intro,
                content: this.modal.tip.content
              }
            ).then(
              response => {
                console.log(response);
                this.modules.tiplist[this.modal.tip.index].title = response.data.data.title;
                this.modules.tiplist[this.modal.tip.index].video = response.data.data.video;
                this.modules.tiplist[this.modal.tip.index].intro = response.data.data.intro;
                this.modules.tiplist[this.modal.tip.index].content = response.data.data.content;
                this.modules.tiplist[this.modal.tip.index].videopreview = response.data.data.videopreview;

                this.modal.isHidden = true;
              }
            )
            break;

          case 'motivators':
            API.patch(
              `index.cfm?act=modules.motivatoritem&id=${this.modal.id}`,
              {
                image_id: this.modal.motivator.id
              }
            ).then(
              response => {
                this.modules.motivatorlist[this.modal.motivator.index].image = response.data.data.image;
            
                this.modal.isHidden = true;
              }
            )
            break;

          case 'issues':
            API.patch(
              `index.cfm?act=modules.issueitem&id=${this.modal.id}`,
              {
                title: this.modal.issue.title,
                situation: this.modal.issue.situation,
                situation_id: this.modal.issue.situation_id,
                description: this.modal.issue.description
              }
            ).then(
              response => {
                this.modules.issuelist[this.modal.issue.index].title = response.data.data.title;
                this.modules.issuelist[this.modal.issue.index].situation = response.data.data.situation;
                this.modules.issuelist[this.modal.issue.index].situation_id = response.data.data.situation_id;
                this.modules.issuelist[this.modal.issue.index].description = response.data.data.description;
                
                this.modal.isHidden = true;
              }
            )
            break;

          case 'moments':
            API.patch(
              `index.cfm?act=modules.momentitem&id=${this.modal.id}`,
              {
                title: this.modal.moment.title,
                intro: this.modal.moment.intro
              }
            ).then(
              response => {
                this.modules.momentlist[this.modal.moment.index].title = response.data.data.title;
                this.modules.momentlist[this.modal.moment.index].intro = response.data.data.intro;
                
                this.modal.isHidden = true;
              }
            )
            break;

          case 'momentstrategy':
            API.patch(
              `index.cfm?act=modules.momentstrategyitem&id=${this.modal.id}`,
              {
                title: this.modal.momentstrategy.title,
                text: this.modal.momentstrategy.text,
                info: this.modal.momentstrategy.info,
                link: this.modal.momentstrategy.link
              }
            ).then(
              response => {
                this.modules.momentstrategylist[this.modal.momentstrategy.index].title = response.data.data.title;
                this.modules.momentstrategylist[this.modal.momentstrategy.index].text = response.data.data.text;
                this.modules.momentstrategylist[this.modal.momentstrategy.index].info = response.data.data.info;
                this.modules.momentstrategylist[this.modal.momentstrategy.index].link = response.data.data.link;
                this.modal.isHidden = true;
              }
            )
            break;

          case 'situations':
            API.patch(
              `index.cfm?act=modules.situationitem&id=${this.modal.id}`,
              {
                title: this.modal.situation.title,
                description: this.modal.situation.description
              }
            ).then(
              response => {
                this.modules.situationlist[this.modal.situation.index].title = response.data.data.title;
                this.modules.situationlist[this.modal.situation.index].description = response.data.data.description;

                this.modal.isHidden = true;
              }
            )
            break;

          case 'strategy':
            console.log('model', this.modal.strategy.link);

            API.patch(
              `index.cfm?act=modules.strategyitem&id=${this.modal.id}`,
              {
                title: this.modal.strategy.title,
                text: this.modal.strategy.text,
                info: this.modal.strategy.info,
                podcast_id: this.modal.strategy.podcast_id,
                link: this.modal.strategy.link,
              }
            ).then(
              response => {

                console.log('response', response);

                this.modules.strategylist[this.modal.strategy.index].title = response.data.data.title;
                this.modules.strategylist[this.modal.strategy.index].text = response.data.data.text;
                this.modules.strategylist[this.modal.strategy.index].info = response.data.data.info;
                this.modules.strategylist[this.modal.strategy.index].podcast_id = response.data.data.podcast_id;
                this.modules.strategylist[this.modal.strategy.index].link = response.data.data.link;

                this.modal.isHidden = true;
              }
            )
            
            break;
        }
      },
      handleDelete: function(index, id) {
        if (confirm("Are you sure you want to delete this item?")) {
          switch (this.$route.name) {
            case 'faq':
              API.delete(
                `index.cfm?act=modules.faqitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.faqlist.splice(index, 1);
                }
              )
              break;

            case 'text':
              API.delete(
                `index.cfm?act=modules.textitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.textlist.splice(index, 1);
                }
              )
              break;
            
            case 'tips':
              API.delete(
                `index.cfm?act=modules.tipcatitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.tipcatlist.splice(index, 1);
                }
              )
              break;
            case 'tip':
              API.delete(
                `index.cfm?act=modules.tipitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.tiplist.splice(index, 1);
                }
              )
              break;

            case 'motivators':
              API.delete(
                `index.cfm?act=modules.motivatoritem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.motivatorlist.splice(index, 1);
                }
              )
              break;

            case 'issues':
              API.delete(
                `index.cfm?act=modules.issueitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.issuelist.splice(index, 1);
                }
              )
              break;

            case 'moments':
              API.delete(
                `index.cfm?act=modules.momentitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.momentlist.splice(index, 1);
                }
              )
              break;

            case 'momentstrategy':
              API.delete(
                `index.cfm?act=modules.momentstrategyitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.momentstrategylist.splice(index, 1);
                }
              )
              break;

            case 'situations':
              API.delete(
                `index.cfm?act=modules.situationitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.situationlist.splice(index, 1);
                }
              )
              break;

            case 'strategy':
              API.delete(
                `index.cfm?act=modules.strategyitem&id=${id}`
              ).then(
                response => {
                  console.log(response);
                  this.modules.strategylist.splice(index, 1);
                }
              )
              break;
          }
        }
      }
    },
    mounted() {
      const self = this;

      // get data
      switch (this.$route.name) {
        case 'faq':
          this.modules.currentModule = 'faqlist';
          this.modules.currentModuleTitle = 'FAQ';

          API.get(
            'index.cfm?act=modules.faqlist'
          ).then(
            response => {
              console.log('faqlist', response.data.data);
              this.modules.faqlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'text':
          this.modules.currentModule = 'textlist';
          this.modules.currentModuleTitle = 'Text';

          API.get(
            'index.cfm?act=modules.textlist'
          ).then(
            response => {
              console.log('textlist', response.data.data);
              this.modules.textlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;
        
        case 'tips':
          this.modules.currentModule = 'tipcatlist';
          this.modules.currentModuleTitle = 'Tips';

          API.get(
            'index.cfm?act=modules.tipcatlist'
          ).then(
            response => {
              console.log('tipcatlist', response.data.data);
              this.modules.tipcatlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'tip':
          this.modules.currentModule = 'tiplist';
          this.modules.currentModuleTitle = 'Tip';

          API.get(
            `index.cfm?act=modules.tiplist&id=${this.$route.params.id}`
          ).then(
            response => {
              console.log('tiplist', response.data.data);
              this.modules.tiplist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });

          API.get(
            `index.cfm?act=modules.tipcatitem&id=${this.$route.params.id}`
          ).then(
            response => {
              console.log('tipcatitem', response.data.data);

              this.modules.tipcatitem = response.data.data;
              // this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'motivators':
          this.modules.currentModule = 'motivatorlist';
          this.modules.currentModuleTitle = 'Motivators';

          API.get(
            'index.cfm?act=modules.motivatorlist'
          ).then(
            response => {
              console.log('motivatorlist', response.data.data);
              this.modules.motivatorlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'issues':
          this.modules.currentModule = 'issuelist';
          this.modules.currentModuleTitle = 'Issues';

          API.get(
            'index.cfm?act=modules.issuelist'
          ).then(
            response => {
              console.log('issuelist', response.data.data);
              this.modules.issuelist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });

          API.get(
            'index.cfm?act=modules.situationlist'
          ).then(
            response => {
              console.log('tipcatlist', response.data.data);
              this.modules.situationlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'moments':
          this.modules.currentModule = 'momentlist';
          this.modules.currentModuleTitle = 'Moments';

          API.get(
            'index.cfm?act=modules.momentlist'
          ).then(
            response => {
              console.log('tipcatlist', response.data.data);
              this.modules.momentlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'momentstrategy':
          this.modules.currentModule = 'momentstrategylist';
          this.modules.currentModuleTitle = 'Moments';

          API.get(
            `index.cfm?act=modules.momentstrategylist&id=${this.$route.params.id}`
          ).then(
            response => {
              console.log('momentstrategylist', response.data.data);
              this.modules.momentstrategylist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'situations':
          this.modules.currentModule = 'situationlist';
          this.modules.currentModuleTitle = 'Situations';

          API.get(
            'index.cfm?act=modules.situationlist'
          ).then(
            response => {
              console.log('tipcatlist', response.data.data);
              this.modules.situationlist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;

        case 'strategy':
          this.modules.currentModule = 'strategylist';
          this.modules.currentModuleTitle = 'Strategy';

          API.get(
            'index.cfm?act=modules.strategylist'
          ).then(
            response => {
              console.log('strategylist', response.data.data);
              this.modules.strategylist = response.data.data;
              this.modules.isLoading = false;
            }
          ).catch(function (error) {
            if (error.response.status === 403) {
              localStorage.removeItem('selectedApplicationName');
              localStorage.removeItem('selectedApplicationId');        
              self.selectedApplicationId = null
            }
          });
          break;
      }

      // check sign in
      if (!localStorage.authenticated) {
        window.location.href = '/login';
      } else if(window.location.pathname === '/modules') {
        window.location.href = '/modules/faq';
      }
    }
  }
</script>

<style lang="scss">
  #modules {

    .dropdown {
      width: 170px;
      float: left;
    }

    .button {
      float: right;
    }

    .table {
      float: left;
    }
  }

  .modules--remove-button {
    margin-bottom: 15px;
    background-color: var(--red);
  }

  .td--image {
    img {
      width: 75px;
    }
    
  }
  
  .item {
    &:hover {
      cursor: move;
      cursor: grab;
    }
  }

  .flip-list-move {
    transition: transform .2s;
  }

  .over {
    opacity: .6;
  }

  .strategylist-moments {
    border: 1px solid var(--blue-medium);
    padding: 10px;
    
    li {
      cursor: pointer;
    }
  }

  .row {
    position: relative;
  }

  .strategy-buttons {
    position: absolute; 
    // left: calc(50% - 8px);
    left: calc(50% - 4px);
    top: calc(50% - 20px);

    a {
      display: block;
      font-size: 10px;
      margin-bottom: 5px;

      &:nth-child(4) {
        margin-right: 9px;
      }

      // &:nth-child(3),
      // &:nth-child(4) {
      //   transform: rotate(180deg)
      // }

      &:nth-child(2) {
        transform: rotate(180deg)
      }
    }
  }

  .motivator-image {
    margin-bottom: 15px;
  }

  .tinymce {
    height: auto !important;
    width: 100%;
    margin-bottom: 15px;

    button {
      span {
        margin-bottom: 0;
      }
      
      span,
      i {
        display: inline-block;
      }
    }
  }

  .tip-placeholder {
    display: none;
  }
</style>
